import React from 'react';
import { Segment, Header, Icon, Grid, Card, Breadcrumb, Image, Modal, Button } from 'semantic-ui-react';

import moment from 'moment';
import './RequestDetailContainer.less';

import { getSingleBuyerRequestDetails, getSbrBidsHistory } from '../../services/Project';

import PhotoCarousel from '../../components/PhotoCarousel/PhotoCarousel';
import TimeCountDown from '../../components/TimeCountDown/TimeCountDown';
import BidHistory from '../../components/BidHistory/BidHistory';
import RequestInfo from '../../components/RequestInfo/RequestInfo';
import { priceDisplay } from '../../helpers/price';

class RequestDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            details: { bid: {}, service: {}, sbr: {}, images: [] },
            openedImageIndex: -1
        }
        this.sbrId = 0;
    }

    async componentDidMount() {
        this.sbrId = this.props.match.params.requestId;
        const details = await getSingleBuyerRequestDetails(this.sbrId);
        let bidsHistory;
        if (details  && details.data && details.data.bid && details.data.bid && details.data.bid.sellerBid) {
            bidsHistory = await getSbrBidsHistory(this.sbrId);
        }
        await this.setState({
            details: details && details.data || { bid: {}, service: {}, sbr: {}, images: [] },
            bidsHistory: bidsHistory && bidsHistory.data || []
        });
    }

    render() {
        const {bidsHistory, details } = this.state;
        const { bid, service, sbr, images } = details;
        return (
            <div className="DashboardContainer animated fadeInRight">
                <Segment.Group>
                    <Segment size="massive" className="no-radius">
                        <Header as="h3">
                            <Header.Content>
                                <Icon name='info circle' size='small' />
                                Request Details
                            </Header.Content>
                        </Header>
                    </Segment>
                    
                </Segment.Group>
                <Grid celled>
                    <Grid.Row>
                        <Grid.Column>
                            <Card fluid>
                                <Card.Content>
                                    <Grid>
                                        <Grid.Row columns={4}>
                                            <Grid.Column width="2"></Grid.Column>
                                            <Grid.Column width="2"><strong>Service:</strong></Grid.Column>
                                            <Grid.Column width="10">{service && service.name || 'N/A'}</Grid.Column>
                                            <Grid.Column width="2"></Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row columns={4}>
                                            <Grid.Column width="2"></Grid.Column>
                                            <Grid.Column width="2"><strong>Initiated:</strong></Grid.Column>
                                            <Grid.Column width="10">{sbr && sbr.initiated && moment(sbr.initiated).format('lll') || null}</Grid.Column>
                                            <Grid.Column width="2"></Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row columns={4}>
                                            <Grid.Column width="2"></Grid.Column>
                                            <Grid.Column width="2"><strong>Request Info:</strong></Grid.Column>
                                            <Grid.Column width="10">{sbr.quickInfo || null}</Grid.Column>
                                            <Grid.Column width="2"></Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row columns={4}>
                                            <Grid.Column width="2"></Grid.Column>
                                            <Grid.Column width="2"><strong>Buyer Notes:</strong></Grid.Column>
                                            <Grid.Column width="10">{sbr && sbr.buyerNotes || 'N/A'}</Grid.Column>
                                            <Grid.Column width="2"></Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row columns={4}>
                                            <Grid.Column width="2"></Grid.Column>
                                            <Grid.Column width="2"><strong>Expires:</strong></Grid.Column>
                                            <Grid.Column width="10"><TimeCountDown date={sbr && sbr.expiry} /></Grid.Column>
                                            <Grid.Column width="2"></Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row columns={4}>
                                            <Grid.Column width="2"></Grid.Column>
                                            <Grid.Column width="2"><strong>Total Bids:</strong></Grid.Column>
                                            <Grid.Column width="10">{bid && bid.totalBids}</Grid.Column>
                                            <Grid.Column width="2"></Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row columns={4}>
                                            <Grid.Column width="2"></Grid.Column>
                                            <Grid.Column width="2"><strong>Current:</strong></Grid.Column>
                                            <Grid.Column width="10">{bid && bid.minBid && priceDisplay(bid.minBid)}</Grid.Column>
                                            <Grid.Column width="2"></Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row columns={4}>
                                            <Grid.Column width="2"></Grid.Column>
                                            <Grid.Column width="2"><strong>Buyer Distance:</strong></Grid.Column>
                                            <Grid.Column width="10">{bid && bid.buyerDistance || 'N/A'}</Grid.Column>
                                            <Grid.Column width="2"></Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row columns={4}>
                                            <Grid.Column width="2"></Grid.Column>
                                            <Grid.Column width="12">
                                                <PhotoCarousel images={images} />
                                            </Grid.Column>
                                            <Grid.Column width="2"></Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row columns={4}>
                                            <Grid.Column width="2"></Grid.Column>
                                            <Grid.Column width="12">
                                                <RequestInfo title="Client Submitted Info" serviceRequestInfo={sbr.serviceFormData} />
                                            </Grid.Column>
                                            <Grid.Column width="2"></Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row columns={4}>
                                            <Grid.Column width="2"></Grid.Column>
                                            <Grid.Column width="12">
                                            </Grid.Column>
                                            <Grid.Column width="2"></Grid.Column>
                                        </Grid.Row>
                                    </Grid>
                                    
                                    <BidHistory bidHistory={bidsHistory} userHas2PlaceBid={bid && !bid.sellerBid} />

                                </Card.Content>
                            </Card>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}

export default RequestDetail;